export enum CompanyRepresentativeTypes {
  ADMINISTRADOR_UNICO = "administrador_unico",
  ADMINISTRADORES_MANCOMUNADOS = "administradores_mancomunados",
  ADMINISTRADORES_SOLIDARIOS = "administradores_solidarios",
  APODERADO = "apoderado",
  CONSEJERO_DELEGADO = "consejero_delegado",
  OTHER = "other",
}
